
   var initialState = {
     open:false,
     info:{}
     };
   
   const AlertReducer = (state = initialState, action) => {
     switch (action.type) {
       //-------Fetch-------//
       case "OPEN":
         return { ...state,open:true,info:action.payload};
        case "CLOSE":
            return { ...state,open:false};
       //----DEFAULT----//
       default:
         return state;
     }
   };
   export default AlertReducer;
   